import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";
const WarehouseTransactionMaster = () => {
  const tableHeaders = [
    "#",
   
    "Product",
    "Variant",
    "Qty",
    "Unit Cost",
    "Total",
    "Gross/Net ",
    "Balance Qty",
    "Final Stock",
    "UOM",
    "Remarks",
    "Action",
  ];

  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();
  const [transactionDetails, setTransactionDetails] = useState({});
      const trxn_id = localStorage.getItem("transac_id");

  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: 1,
    trxn_id: localStorage.getItem("transac_id"),
    wh_product_id: "",
    wh_variant_id: "",
    qty: "",
    unit_cost: "",
    total: "",
    remarks: "",
    gross_weight: "",
    net_weight: "",
    balance_qty: "",
    final_stock_availability_to_app: "",
    uom: "",
  });

  // Fetch initial data
  useEffect(() => {
    fetchData();
    fetchProductData();
    fetchVariantData();
     const details = {
      transaction_id: localStorage.getItem("transac_id"),
      trxn_date: localStorage.getItem("transac_date"),
 trxn_type: Number(localStorage.getItem("transac_type")),    
      remarks: localStorage.getItem("remarks"),
      created_by: localStorage.getItem("created_by"),
    };
    setTransactionDetails(details);
  }, []);

  const getLabel = (list, value) => {
  const found = list?.find(item => item.value === value);
  return found ? found.label : "";
};


  const trxnTypeOptions = [
    { value: 1, label: "IN" },
    { value: 2, label: "OUT" },
    { value: 3, label: "WASTAGE" },
    { value: 4, label: "ADJUSTMENT" },
  ];

 


  const fetchData = async () => {
  const trxn_id = localStorage.getItem("transac_id");
  try {
    setInitialLoading(true);
    const res = await axios.get(`${var_api}veemart_appstore_inventory_transaction_details/getByTrxnId/${trxn_id}`);

    // ✅ Ensure data is always an array
    const apiData = Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data?.data)
      ? res.data.data
      : [];

    setData(apiData);
  } catch (err) {
    // toast.error("Failed to fetch data");
    setData([]); // prevent further crashes
  } finally {
    setInitialLoading(false);
  }
};


  const fetchProductData = async () => {
    const catId = localStorage.getItem("cat_id");
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setProductData(allProducts);
    } catch (err) {
      console.error("Error fetching products:", err);
      toast.error("Failed to fetch product data");
    }
  };

const [allVariantData, setAllVariantData] = useState([]);

const fetchVariantData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
    const allData = res.data || [];
    setAllVariantData(allData); // store all variants
    setVariantData(allData); // default show all
  } catch (err) {
    toast.error("Failed to fetch variant data");
  }
};

 const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    let updatedForm = { ...prev, [name]: value };

    // Auto calculate total when qty or unit_cost changes
    if (name === "qty" || name === "unit_cost") {
      const qty = parseFloat(name === "qty" ? value : prev.qty) || 0;
      const unitCost = parseFloat(name === "unit_cost" ? value : prev.unit_cost) || 0;
      updatedForm.total = (qty * unitCost).toFixed(2);
    }

    return updatedForm;
  });

  setErrors((prev) => ({ ...prev, [name]: "" }));
};


 const handleSelectChange = (selected, name) => {
  const value = selected ? selected.value : "";

  setFormData((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: "" }));

  // When product changes, filter variant list
  if (name === "wh_product_id") {
    const filteredVariants = allVariantData.filter(
      (v) => String(v.product_id) === String(value)
    );
    setVariantData(filteredVariants);
    setFormData((prev) => ({ ...prev, wh_variant_id: "" })); // reset variant
  }
};


  const handleAdd = () => {
    setFormData({
      id: null,
      warehouse_id: 1,
    trxn_id: localStorage.getItem("transac_id"),
      wh_product_id: "",
      wh_variant_id: "",
      qty: "",
      unit_cost: "",
      total: "",
      remarks: "",
      gross_weight: "",
      net_weight: "",
      balance_qty: "",
      final_stock_availability_to_app: "",
      uom: "",
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.wh_product_id) newErrors.wh_product_id = "Product is required";
    if (!formData.wh_variant_id) newErrors.wh_variant_id = "Variant is required";
 if (!formData.qty) {
    newErrors.qty = "Quantity is required";
  } else if (isNaN(formData.qty) || Number(formData.qty) <= 0) {
    newErrors.qty = "Quantity must be greater than 0";
  }

  // Unit Cost validation
  if (!formData.unit_cost) {
    newErrors.unit_cost = "Unit cost is required";
  } else if (isNaN(formData.unit_cost) || Number(formData.unit_cost) <= 0) {
    newErrors.unit_cost = "Unit cost must be greater than 0";
  }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fix the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode) {
        res = await axios.put(
          `${var_api}veemart_appstore_inventory_transaction_details/update/${formData.id}`,
          formData
        );
      } else {
        res = await axios.post(`${var_api}veemart_appstore_inventory_transaction_details/post`, formData);
      }
      toast.success(res?.data?.message || "Saved successfully");
      setShowModal(false);
      fetchData();
    } catch (err) {
      toast.error("Failed to save record");
    } finally {
      setLoading(false);
    }
  };
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
  // Filter & Pagination
 const filteredData = data.filter((item) => {
  const productName =
    productData.find((p) => String(p.id) === String(item.wh_product_id))
      ?.product_name || "";

  const variantName =
    allVariantData.find((v) => String(v.id) === String(item.wh_variant_id))
      ?.variant_name || "";

  // Combine relevant searchable fields
  const searchableString = [
    productName,
    variantName,
    item.qty,
    item.unit_cost,
    item.total,
    item.gross_weight,
    item.net_weight,
    item.uom,
    item.remarks,
  ]
    .join(" ")
    .toLowerCase();

  return searchableString.includes(searchQuery.toLowerCase());
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
    <Card className="p-3 mb-3 position-relative">
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="mb-0">Warehouse Transaction Details</h5>

    {/* 🔙 Back Button */}
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => navigate("/appstore-inventory")}
    >
      <i className="fas fa-arrow-left me-2"></i> Back to Transactions
    </Button>
  </div>

  <Row className="g-3">
   

    <Col xs="auto">
      <strong>Transaction Date:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {formatDate(transactionDetails.trxn_date)}
      </span>
    </Col>

 <Col xs="auto">
  <strong>Transaction Type:</strong>{" "}
  <span style={{ color: "green", fontWeight: "600" }}>
    {getLabel(trxnTypeOptions, transactionDetails.trxn_type)}
  </span>
</Col>




  

  
  </Row>
</Card>

          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button variant="secondary" onClick={handleAdd}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>
                      {tableHeaders.map((h, i) => (
                        <th key={i}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="14" className="text-center text-muted py-3">
                          No records found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                        <td>
  {
    productData.find((p) => String(p.id) === String(item.wh_product_id))
      ?.product_name || "-"
  }
</td>
<td>
  {
    allVariantData.find((v) => String(v.id) === String(item.wh_variant_id))
      ?.variant_name || "-"
  }
</td>

                          <td>{item.qty}</td>
                          <td>{item.unit_cost}</td>
                          <td>{item.total}</td>
                          <td>{item.gross_weight}/{item.net_weight}</td>
                          <td>{item.balance_qty}</td>
                          <td>{item.final_stock_availability_to_app}</td>
                          <td>{item.uom}</td>
                          <td>{item.remarks}</td>
                          <td>
                             <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEdit(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      className="me-1"
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Warehouse Transaction" : "Add Warehouse Transaction"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
           

             

              {/* Product Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Product <span className="text-danger">*</span></Form.Label>
                  <Select
                    options={productData.map((p) => ({
                      label: p.product_name,
                      value: p.id,
                    }))}
                    value={
                      formData.wh_product_id
                        ? {
                            label:
                              productData.find(
                                (p) => p.id === formData.wh_product_id
                              )?.product_name || "Select Product",
                            value: formData.wh_product_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "wh_product_id")
                    }
                  />
                  {errors.wh_product_id && (
                    <div className="text-danger small mt-1">{errors.wh_product_id}</div>
                  )}
                </Form.Group>
              </Col>

              {/* Variant Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Variant <span className="text-danger">*</span></Form.Label>
                  <Select
                    options={variantData.map((v) => ({
                      label: v.variant_name,
                      value: v.id,
                    }))}
                    value={
                      formData.wh_variant_id
                        ? {
                            label:
                              variantData.find(
                                (v) => v.id === formData.wh_variant_id
                              )?.variant_name || "Select Variant",
                            value: formData.wh_variant_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "wh_variant_id")
                    }
                  />
                  {errors.wh_variant_id && (
                    <div className="text-danger small mt-1">{errors.wh_variant_id}</div>
                  )}
                </Form.Group>
              </Col>

              {/* Remaining fields */}
            {/* Quantity */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Quantity <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"
      name="qty"
      min="1"
      placeholder="Enter quantity"
      value={formData.qty}
      onChange={handleInputChange}
      isInvalid={!!errors.qty}
    />
    {errors.qty && <div className="text-danger small mt-1">{errors.qty}</div>}
  </Form.Group>
</Col>

{/* Unit Cost */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>
      Unit Cost <span className="text-danger">*</span>
    </Form.Label>
    <Form.Control
      type="number"
      name="unit_cost"
      min="1"
      placeholder="Enter unit cost"
      value={formData.unit_cost}
      onChange={handleInputChange}
      isInvalid={!!errors.unit_cost}
    />
    {errors.unit_cost && (
      <div className="text-danger small mt-1">{errors.unit_cost}</div>
    )}
  </Form.Group>
</Col>


              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Total</Form.Label>
                 <Form.Control
  type="number"
  name="total"
  value={formData.total}
  readOnly
/>

                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Gross Weight</Form.Label>
                  <Form.Control
                    type="text"
                    name="gross_weight"
                    min="1"
                    placeholder="Enter Gross"
                    value={formData.gross_weight}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Net Weight</Form.Label>
                  <Form.Control
                    type="number"
                    name="net_weight"
                     min="1"
                    placeholder="Enter Net"
                    value={formData.net_weight}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Balance Qty</Form.Label>
                  <Form.Control
                    type="number"
                    name="balance_qty"
                      min="1"
                    placeholder="Enter Balance Qty"
                    value={formData.balance_qty}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Final Stock Availability</Form.Label>
                  <Form.Control
                    type="text"
                    name="final_stock_availability_to_app"
                                        placeholder="Final Stock Availability"

                    value={formData.final_stock_availability_to_app}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>UOM</Form.Label>
                  <Form.Control
                    type="text"
                    name="uom"
                                                            placeholder="Enter Uom"

                    value={formData.uom}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="remarks"
                    placeholder="Enter Remarks"
                    value={formData.remarks}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

             <div className="d-flex justify-content-end gap-2">
                          {!isEditMode ? (
                            <>
                              <Button variant="secondary" type="submit" disabled={loading}>
                                {loading ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Creating...
                                  </>
                                ) : (
                                  "Create"
                                )}
                              </Button>
                              <Button
                                variant="danger"
                                type="reset"
                                disabled={loading}
                                onClick={() =>
                                  setFormData({
                                id: null,
    warehouse_id: 1,
    trxn_id: localStorage.getItem("transac_id"),
    wh_product_id: "",
    wh_variant_id: "",
    qty: "",
    unit_cost: "",
    total: "",
    remarks: "",
    gross_weight: "",
    net_weight: "",
    balance_qty: "",
    final_stock_availability_to_app: "",
    uom: "",
                                  })
                                }
                              >
                                Reset
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button variant="warning" type="submit" disabled={loading}>
                                {loading ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Updating...
                                  </>
                                ) : (
                                  "Update"
                                )}
                              </Button>
                              <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                                Cancel
                              </Button>
                            </>
                          )}
                        </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default WarehouseTransactionMaster;
